<template>
	<div class="card">
		<h1>{{$t('Skills')}}</h1>
		<div class="p-grid">
			<div class="p-col-12 p-md-2">
				<DataTable :value="selectedAthleticProfileSkills" dataKey="Id">
					<Column field="Name" :header="$t('AthleticProfile')">
						<template #body="slotProps">
							<span>{{ slotProps.data.Name }}</span>
							<div v-if="slotProps.data.Evaluations > 0" class="skill_circle" >
								<span v-tooltip.top="slotProps.data.EvaluationsNames">{{ slotProps.data.Evaluations }}</span>
							</div>
						</template>
					</Column>
				</DataTable>
			</div>
			<div class="p-col-12 p-md-2">
				<DataTable :value="selectedPsychologicalAspectSkills" dataKey="Id">
					<Column field="Name" :header="$t('PsychologicalAspect')">
						<template #body="slotProps">
							<span>{{ slotProps.data.Name }}</span>
							<div v-if="slotProps.data.Evaluations > 0" class="skill_circle">
								<span v-tooltip.top="slotProps.data.EvaluationsNames">{{ slotProps.data.Evaluations }}</span>
							</div>
						</template>
					</Column>
				</DataTable>
			</div>
			<div class="p-col-12 p-md-2">
				<DataTable :value="selectedTechnicalAspectSkills" dataKey="Id">
					<Column field="Name" :header="$t('TechnicalAspect')">
						<template #body="slotProps">
							<span>{{ slotProps.data.Name }}</span>
							<div v-if="slotProps.data.Evaluations > 0" class="skill_circle">
								<span v-tooltip.top="slotProps.data.EvaluationsNames">{{ slotProps.data.Evaluations }}</span>
							</div>
						</template>
					</Column>
				</DataTable>
			</div>
			<div class="p-col-12 p-md-2">
				<DataTable :value="selectedOffensiveQualitiesSkills" dataKey="Id">
					<Column field="Name" :header="$t('OffensiveQualities')">
						<template #body="slotProps">
							<span>{{ slotProps.data.Name }}</span>
							<div v-if="slotProps.data.Evaluations > 0" class="skill_circle">
								<span v-tooltip.top="slotProps.data.EvaluationsNames">{{ slotProps.data.Evaluations }}</span>
							</div>
						</template>
					</Column>
				</DataTable>
			</div>
			<div class="p-col-12 p-md-2">
				<DataTable :value="selectedDefensiveQualitiesSkills" dataKey="Id">
					<Column field="Name" :header="$t('DefensiveQualities')">
						<template #body="slotProps">
							<span>{{ slotProps.data.Name }}</span>
							<div v-if="slotProps.data.Evaluations > 0" class="skill_circle">
								<span v-tooltip.top="slotProps.data.EvaluationsNames">{{ slotProps.data.Evaluations }}</span>
							</div>
						</template>
					</Column>
				</DataTable>
			</div>
		</div>
	</div>
</template>

<script>
import EnumService from "@/service/EnumService";

export default {
	props: ["value", "skillsEvaluations", "skillsEvaluationsNames"],
	data: function () {
		return {
			selectedAthleticProfileSkills: [],
			selectedPsychologicalAspectSkills: [],
			selectedTechnicalAspectSkills: [],
			selectedOffensiveQualitiesSkills: [],
			selectedDefensiveQualitiesSkills: [],
		};
	},
	enumService: null,
	mounted() {
		this.enumService = new EnumService();
		let self = this;
		if (this.value != null) {
			this.value.forEach(function (skill) {
				if (skill > 0 && skill <= 8)
					self.selectedAthleticProfileSkills.push({
						Id: skill,
						Name: self.enumService.getEnumName(
							self.enumService.getAthleticProfileSkillsEnum(),
							skill
						),
						Evaluations: self.skillsEvaluations
							? self.skillsEvaluations[skill]
							: 0,
						EvaluationsNames: self.skillsEvaluations
							? self.skillsEvaluationsNames[skill]
							: null,
					});
				if (skill > 8 && skill <= 16)
					self.selectedPsychologicalAspectSkills.push({
						Id: skill,
						Name: self.enumService.getEnumName(
							self.enumService.getPsychologicalAspectSkillsEnum(),
							skill
						),
						Evaluations: self.skillsEvaluations
							? self.skillsEvaluations[skill]
							: 0,
						EvaluationsNames: self.skillsEvaluations
							? self.skillsEvaluationsNames[skill]
							: null,
					});
				if (skill > 16 && skill <= 26)
					self.selectedTechnicalAspectSkills.push({
						Id: skill,
						Name: self.enumService.getEnumName(
							self.enumService.getTechnicalAspectSkillsEnum(),
							skill
						),
						Evaluations: self.skillsEvaluations
							? self.skillsEvaluations[skill]
							: 0,
						EvaluationsNames: self.skillsEvaluations
							? self.skillsEvaluationsNames[skill]
							: null,
					});
				if (skill > 26 && skill <= 33)
					self.selectedOffensiveQualitiesSkills.push({
						Id: skill,
						Name: self.enumService.getEnumName(
							self.enumService.getOffensiveQualitiesSkillsEnum(),
							skill
						),
						Evaluations: self.skillsEvaluations
							? self.skillsEvaluations[skill]
							: 0,
						EvaluationsNames: self.skillsEvaluations
							? self.skillsEvaluationsNames[skill]
							: null,
					});
				if (skill > 33 && skill <= 40)
					self.selectedDefensiveQualitiesSkills.push({
						Id: skill,
						Name: self.enumService.getEnumName(
							self.enumService.getDefensiveQualitiesSkillsEnum(),
							skill
						),
						Evaluations: self.skillsEvaluations
							? self.skillsEvaluations[skill]
							: 0,
						EvaluationsNames: self.skillsEvaluations
							? self.skillsEvaluationsNames[skill]
							: null,
					});
			});
		}
	},
};
</script>

<style scoped>
.skill_circle {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	font-size: 10px;
	color: #fff;
	line-height: 26px;
	text-align: center;
	background: #007ad9;
	position: relative;
	float: right;
	cursor: zoom-in !important;
}
</style>